import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  propertyStar: "",
  hotelName: "",
  neighbourhood: "",
  hotelFacilities: "",
  roomFacilities: "",
  minPrice: "",
  maxPrice: "",
  sorting: "",
  page: 1,
  limit: 10,
};

export const hotelFilterSlice = createSlice({
  name: "hotelFilterSlice",
  initialState,
  reducers: {
    setPropertyStar: (state, action) => {
      state.propertyStar = action.payload;
    },
    setHotelName: (state, action) => {
      state.hotelName = action.payload;
    },
    setNeighbourhood: (state, action) => {
      state.neighbourhood = action.payload;
    },
    setHotelFacilities: (state, action) => {
      state.hotelFacilities = action.payload;
    },
    setRoomFacilities: (state, action) => {
      state.roomFacilities = action.payload;
    },
    setMinPrice: (state, action) => {
      state.minPrice = action.payload;
    },
    setMaxPrice: (state, action) => {
      state.maxPrice = action.payload;
    },
    setSorting: (state, action) => {
      state.sorting = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
  },
});

export const {
  setPropertyStar,
  setHotelName,
  setNeighbourhood,
  setHotelFacilities,
  setRoomFacilities,
  setMinPrice,
  setMaxPrice,
  setSorting,
  setPage,
  setLimit,
} = hotelFilterSlice.actions;

export default hotelFilterSlice.reducer;
